import Axios from 'axios'
import {
    SIGNUP,
    SIGNUP_FAILED,
    SIGNUP_SUCCESSFUL,

}  from '../constant/index'
const BASE_URL = process.env.REACT_APP_BASE_URL;
console.log(BASE_URL)

export const signin = (email, password) => async (dispatch) => {
    dispatch({
        type: SIGNUP
    })
    console.log(email, password)
    try {
        const { data } = await Axios.post(`${BASE_URL}/accounts/user/login`, {
            "email": email,
            "password": password
        },
        {
           headers: {
               "Content-Type": "application/json" // Set the content type header
   }})
        

        dispatch({
            type: SIGNUP_SUCCESSFUL,
            payload: data
        })

            // Saving the auth token to session storage
    sessionStorage.setItem("userInfo", JSON.stringify(data));
    console.log(data)
    }
    catch (error) {
        dispatch({
            type: SIGNUP_FAILED,
            payload: error
        })
        console.log(error?.response?.data?.detail)
        window.alert(`${error?.response?.data?.detail}. Please navigate to create account page`)
    }
    
}



